module.exports = {
	"id": "LV",
	"name": "Latvia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.01626,
			"7": 0.00813,
			"8": null,
			"9": null,
			"10": 0.00813,
			"11": 0.02439,
			"12": 0.01626,
			"13": 0.02439,
			"14": 0.01626,
			"15": 0.02439,
			"16": 0.02439,
			"17": 0.02439,
			"18": 0.06504,
			"19": 0.01626,
			"20": 0.01626,
			"21": 0.03252,
			"22": 0.0813,
			"23": 0.01626,
			"24": 0.01626,
			"25": 0.01626,
			"26": 0.03252,
			"27": 0.03252,
			"28": 0.01626,
			"29": 0.01626,
			"30": null,
			"31": 0.07317,
			"32": 0.01626,
			"33": 0.02439,
			"34": 0.03252,
			"35": 0.03252,
			"36": 0.02439,
			"37": 0.01626,
			"38": 0.03252,
			"39": 0.08943,
			"40": 0.04878,
			"41": 0.04878,
			"42": 0.02439,
			"43": 0.14634,
			"44": 0.07317,
			"45": 0.04065,
			"46": 0.05691,
			"47": 0.07317,
			"48": 0.21138,
			"49": 2.22762,
			"50": 0.26016,
			"51": 1.20324,
			"52": 0.60162,
			"53": 30.7314,
			"54": 9.96738,
			"55": 0.20325,
			"56": 0.06504,
			"57": null
		},
		"firefox": {
			"2": 0.02439,
			"3": 0.04878,
			"4": 0.00813,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.03252,
			"11": 0.02439,
			"12": 0.00813,
			"13": null,
			"14": 0.01626,
			"15": 0.01626,
			"16": 0.05691,
			"17": 0.00813,
			"18": null,
			"19": 0.00813,
			"20": 0.01626,
			"21": 0.01626,
			"22": null,
			"23": null,
			"24": 0.02439,
			"25": 0.00813,
			"26": 0.01626,
			"27": 0.00813,
			"28": 0.04065,
			"29": null,
			"30": 0.01626,
			"31": 0.04065,
			"32": 0.00813,
			"33": 0.02439,
			"34": 0.03252,
			"35": 0.04065,
			"36": 0.02439,
			"37": 0.03252,
			"38": 0.11382,
			"39": 0.05691,
			"40": 0.06504,
			"41": 0.04878,
			"42": 0.17886,
			"43": 0.20325,
			"44": 0.13008,
			"45": 0.31707,
			"46": 0.21138,
			"47": 0.85365,
			"48": 0.63414,
			"49": 12.26817,
			"50": 0.11382,
			"51": 0.01626,
			"52": null,
			"3.5": 0.07317,
			"3.6": 0.18699
		},
		"opera": {
			"9": null,
			"11": 0.01626,
			"12": 0.07317,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01626,
			"19": 0.01626,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.00813,
			"25": null,
			"26": null,
			"27": 0.03252,
			"28": 0.00813,
			"29": 0.00813,
			"30": 0.00813,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.00813,
			"35": 0.01626,
			"36": 0.14634,
			"37": 0.04878,
			"38": 0.21138,
			"39": 0.04878,
			"40": 1.53657,
			"41": 0.2439,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.04878,
			"11.1": 0.01626,
			"11.5": 0.00813,
			"11.6": 0.07317,
			"12.1": 0.38211
		},
		"safari": {
			"0": null,
			"4": 0.04065,
			"5": 0.06504,
			"6": 0.02439,
			"7": 0.02439,
			"8": 0.12195,
			"9": 0.17073,
			"10": 1.50405,
			"3.1": 0.00813,
			"3.2": null,
			"5.1": 0.12195,
			"6.1": 0.04878,
			"7.1": null,
			"9.1": 0.75609
		},
		"ios_saf": {
			"8": 0,
			"10": 2.92225413822,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0787513676103,
			"8.1-8.4": 0.145489814738,
			"9.0-9.2": 0.0694079850125,
			"9.3": 1.05891669442
		},
		"android": {
			"3": 0,
			"4": 0.0161003617571,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00201254521964,
			"4.1": 0.0580763049096,
			"4.2-4.3": 0.145190762274,
			"4.4": 0.33293248062,
			"4.4.3-4.4.4": 0.33580754522
		},
		"ie": {
			"6": 0.00829524390244,
			"7": 0.0165904878049,
			"8": 0.356695487805,
			"9": 0.207381097561,
			"10": 0.207381097561,
			"11": 3.28491658537,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0192150618415,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00053375171782
		},
		"edge": {
			"12": 0.07317,
			"13": 0.51219,
			"14": 1.32519
		},
		"ie_mob": {
			"10": 0.0969766197183,
			"11": 0.394833380282
		},
		"bb": {
			"7": 0.0051425,
			"10": null
		},
		"samsung": {
			"0": 2.64231
		},
		"and_uc": {
			"0": 0.13838
		},
		"op_mini": {
			"0": 0.258881186441
		},
		"and_chr": {
			"0": 10.84805
		},
		"and_ff": {
			"0": 0.02057
		}
	},
	"total": 94.3858325
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LV.json
 ** module id = 580
 ** module chunks = 0
 **/